// extracted by mini-css-extract-plugin
export default {"wrapper":"CustomInput_wrapper__SO53x","label":"CustomInput_label__Aghkb","errorMessage":"CustomInput_errorMessage__jMAik"};